<template>
  <div>
    <UtteranceControl
      v-bind="$attrs"
      :disabled-enter="disabled"
      v-on="$listeners"
    ></UtteranceControl>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { UtteranceControl } from '@/components/resources';

@Component({
  components: {
    UtteranceControl
  }
})
export default class SurveyControl extends Vue {
  get disabled() {
    // 若在回看状态下则不禁用，防止对话最后一条是问卷按钮禁用，导致无法下一条
    return !this.$store.state.common.isLookBack;
  }
}
</script>
